import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "toggleButton", "buttonText"];
  static values = { formType: String };

  toggle() {
    if (this.formTarget.classList.contains("hidden")) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  expand() {
    this.formTarget.classList.remove("hidden");
    this.buttonTextTarget.textContent = "Cancel";
    this.toggleButtonTarget.classList.remove(
      "bg-primary-600",
      "hover:bg-primary-700",
    );
    this.toggleButtonTarget.classList.add("bg-gray-600", "hover:bg-gray-700");

    // Change icon to minus
    const icon = this.toggleButtonTarget.querySelector("svg");
    if (icon) {
      icon.innerHTML =
        '<path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />';
    }
  }

  collapse() {
    this.formTarget.classList.add("hidden");
    this.buttonTextTarget.textContent =
      this.formTypeValue === "api-key" ? "Create API Key" : "Create Webhook";
    this.toggleButtonTarget.classList.remove(
      "bg-gray-600",
      "hover:bg-gray-700",
    );
    this.toggleButtonTarget.classList.add(
      "bg-primary-600",
      "hover:bg-primary-700",
    );

    // Change icon back to plus
    const icon = this.toggleButtonTarget.querySelector("svg");
    if (icon) {
      icon.innerHTML =
        '<path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />';
    }

    // Clear any form data
    const form = this.formTarget.querySelector("form");
    if (form) {
      form.reset();
    }
  }

  // Auto-collapse after successful form submission
  handleSuccess() {
    this.collapse();
    // Show success message
    this.showToast(
      `${this.formTypeValue === "api-key" ? "API Key" : "Webhook"} created successfully!`,
      "success",
    );
  }

  showToast(message, type = "info") {
    window.showToast(message, type);
  }
}
